var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-body-2 mt-3 mx-3 pa-3 v-card v-card--link v-sheet theme--dark elevation-20 relative primary",
    staticStyle: {
      "min-width": "200px",
      "max-width": "300px"
    },
    style: {
      'pointer-events': _vm.persistent ? 'none' : 'auto'
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [!_vm.persistent ? _c('v-btn', {
    staticClass: "ma-n2 mb-1 ml-1 float-right",
    attrs: {
      "icon": "",
      "dark": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1) : _vm._e(), _vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }